import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './FAQ.module.css';

const defaultFaqs = [
  {
    q: "What is the lead time for equipment delivery?",
    a: "Lead times vary by product and availability. Standard models from our local stock can be delivered within 1–2 weeks. For custom configurations or larger units, lead times typically range from 4–12 weeks. Contact us for a specific quote."
  },
  {
    q: "Do you offer service and maintenance contracts?",
    a: "Absolutely. We offer flexible service contracts ranging from annual preventive maintenance visits to comprehensive full-service agreements covering all parts, labor, and 24/7 emergency response."
  },
  {
    q: "Are spare parts readily available?",
    a: "We maintain a substantial stock of genuine OEM spare parts for all brands we represent. Critical wear parts are typically available from our local warehouse, ensuring minimal downtime for your operations."
  },
  {
    q: "Can you conduct an energy audit of our compressed air system?",
    a: "Yes, our team of energy specialists can perform comprehensive compressed air audits using calibrated measurement equipment. We identify inefficiencies and provide a detailed report with recommendations that typically yield 20–35% energy savings."
  },
  {
    q: "What financing or rental options are available?",
    a: "We offer several flexible acquisition options including outright purchase, leasing, and equipment rental for short-term or emergency needs. Contact our sales team to discuss the best option for your situation."
  }
];

export default function FAQ({ faqs = defaultFaqs, title = 'Frequently Asked Questions' }) {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <section className={`${styles.section} section`}>
      <div className="container">
        <div className={styles.header}>
          <p className="section-label">Support</p>
          <h2 className="section-title">{title}</h2>
        </div>
        <div className={styles.list}>
          {faqs.map((faq, i) => (
            <div key={i} className={`${styles.item} ${open === i ? styles.itemOpen : ''}`}>
              <button className={styles.question} onClick={() => toggle(i)}>
                <span>{faq.q}</span>
                <ChevronDown size={18} className={`${styles.icon} ${open === i ? styles.iconOpen : ''}`} />
              </button>
              {open === i && (
                <div className={styles.answer}>
                  <p>{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
